// SaaSQuoteStatus.js
import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Button, Heading, Box, Tip } from 'grommet';
import { ShareOption} from 'grommet-icons';
import Iframe from 'react-iframe';


const QlikProdColoExampleComp = () => {
//  const size = useContext(ResponsiveContext);
//  const year = new Date().getFullYear();


  return (
    <Card height="450px" elevation="medium">
      <CardHeader pad={{ horizontal: 'medium', top: 'small', bottom: 'none' }}>
        <Box>
          <Heading margin="none" level={2} pad="none">
            Bar Chart (Qlik- prod colo)
          </Heading>
        </Box>
      </CardHeader>
      <CardBody pad={{ horizontal: 'medium', top: 'none', bottom: 'small' }} gap="small" align="start" fill>
        <Iframe url="https://qlik-sense-cp-prd.its.hpecorp.net/internal/single/?appid=23139862-593a-41e2-9538-6cbe710a87f6&obj=LzdzACH&theme=card&opt=ctxmenu,currsel&identity=preview"
          width="100%" 
          height="100%"
          frameBorder="0"
          overflow="visible"
          allowFullScreen
          scrolling="no"
          id=""
          className=""/>
      </CardBody> 
      <CardFooter pad={{horizontal: "small"}} background="light-2">
        <Tip content="Share with colleagues...">
          <Button icon={<ShareOption color="plain" />} 
                  href="mailto:?subject=GT Console...&body=https://gt-ops.it.hpe.com"
                  hoverIndicator />
        </Tip>
      </CardFooter>        
    </Card>
  );
};

export { QlikProdColoExampleComp as QlikProdColoExample };
